import DOMPurify from "dompurify"
import fm from "front-matter"
import { marked } from "marked"
import type { MarkdownContent, TemplateType } from "../types"

// Configure marked to support all features and allow HTML
marked.setOptions({
  gfm: true,
  breaks: false,
  pedantic: false,
})

export function parseMarkdown(markdown: string): MarkdownContent {
  // Extract frontmatter using front-matter (no eval, safer than gray-matter)
  const { attributes, body } = fm<Record<string, unknown>>(markdown)
  const data = attributes
  const content = body

  // Parse markdown to HTML
  const rawHtml = marked.parse(content) as string

  // Sanitize HTML (allow all tags and attributes for our use case)
  const html = DOMPurify.sanitize(rawHtml, {
    ADD_TAGS: ["style", "script"],
    ADD_ATTR: [
      "target",
      "class",
      "style",
      "width",
      "height",
      "colspan",
      "colgroup",
      "id",
      "alt",
      "src",
      "href",
      "type",
    ],
    ALLOW_DATA_ATTR: true,
    KEEP_CONTENT: true,
    FORCE_BODY: false,
  })

  return {
    title: (data.title as string) || "Blake & Christie",
    template: (data.template as TemplateType) || "splash",
    html,
    frontmatter: data,
  }
}
